<template>
	<b-modal
		id="deleteTopicModal"
		v-model="context.deleteModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
	>
		<div class="modalheading d-flex align-items-center justify-content-between">
			Caution
			<img src="../../../assets/deletepopupicon.svg" alt="" />
		</div>
		<div @click="closedeletemodal()" class="xMarkCancel">
			<img src="../../../assets/xmark.svg" alt="" />
		</div>
		<hr />
		<div class="mt-3 text-break caution-modal-text">
			<span>Are you sure you want to delete "{{ clone.name }}" ?</span>
		</div>
		<div class="normaltext">
			<span class="asterik">*</span
			><span>Please note this action cannot be undone</span>
		</div>
		<div class="d-flex align-items-center justify-content-end mt-3">
			<b-button class="addbtn" @click="deleteTopic()">Delete</b-button>
		</div>
	</b-modal>
</template>

<script>
import { deleteTopicData } from "../asynchronous";
export default {
	name: "DeleteTopicModal",
	data() {
		return {};
	},
	props: {
		clone: Object,
		context: Object,
	},
	methods: {
		async deleteTopic() {
			await deleteTopicData(this.context);
		},
		closedeletemodal() {
			this.$bvModal.hide("deleteTopicModal");
			this.context.$emit(
				"card-option",
				this.context.topicDetails.topicID,
				false
			);
			this.context.selTopic = "";
		},
	},
};
</script>
